import styled from 'styled-components';
import { Container } from '../../styles/Common';

const HowCanWeHelp = () => {
  return (
    <>
      <Container>
        <Wrapper>
          <TopHeadingWrapper>
            <Title>OUR CORE SERVICES</Title>
            <Heading>HOW WE CAN HELP</Heading>
          </TopHeadingWrapper>
          <CardWrapper>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/flows.gif" alt="envelop" />
                <h2>Flows</h2>
              </div>
              <p className="text">
                Automated emails/sms specifically designed to trigger based on
                customer behavior on your website. A MUST have no matter the
                size of your company.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/campaigns.gif" alt="envelop" />
                <h2>Campaigns</h2>
              </div>
              <p className="text">
                Holidays and celebrations are perfect times to CAPITALIZE. Info
                emails, holiday deals, promo sales, anything you'd need to
                communicate. We deliver it.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/growth.gif" alt="envelop" />
                <h2>Growth</h2>
              </div>
              <p className="text">
                Reading and extrapolating data is the key to effective
                marketing. Our team consistently reflects on data to deliver you
                the best results.
              </p>
            </SingleCard>
          </CardWrapper>
        </Wrapper>
      </Container>
    </>
  );
};

export default HowCanWeHelp;

const Wrapper = styled.div`
  padding: 55px 0;
  margin-bottom: 100px;

  @media (max-width: 576px) {
    margin-bottom: 0;
  }
`;

const TopHeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 70px;
`;

const Title = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 1px;
  color: #5ca4ed;
  text-align: center;
  letter-spacing: 3px;
  margin-bottom: 15px;
`;

const Heading = styled.h2`
  text-align: center;
  font-weight: 700;
  font-size: 55px;
  text-transform: uppercase;
  background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 576px) {
    font-size: 35px;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;

  @media (max-width: 576px) {
    padding: 0 15px;
  }
`;

const SingleCard = styled.div`
  width: 32%;
  background: #ffffff;
  box-shadow: 30px 40px 60px rgba(0, 0, 0, 0.06);
  border-radius: 15px;
  padding: 30px 30px 45px 30px;
  display: flex;
  /* justify-content: space-between; */
  flex-direction: column;
  transition: 0.3s;
  margin-bottom: 0;

  .top {
    flex-direction: column;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    img {
      width: 130px;
      height: auto;
      margin-bottom: 35px;
    }

    h2 {
      font-weight: 600;
      font-family: font-semibold;
      font-size: 25px;
      color: #000000;
      text-align: center;
      line-height: 1.4;
      transition: 0.3s;
    }
  }

  p.text {
    font-weight: 500;
    font-family: font-medium;
    font-size: 18px;
    text-align: center;

    color: rgb(152, 159, 179);

    line-height: 1.7;
    transition: 0.3s;
  }
  /* 
  &:hover {
    background: #5da5ed;

    .top {
      h2 {
        color: #fff;
      }
    }

    p.text {
      color: #fff;
    }
  } */

  @media (max-width: 576px) {
    width: 100%;
    padding: 15px;
    margin-bottom: 15px;

    .top {
      flex-direction: column;
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      img {
        width: 130px;
        height: auto;
        margin-bottom: 35px;
      }

      h2 {
        font-weight: 600;
        font-family: font-semibold;
        font-size: 25px;
        color: #000000;
        text-align: center;
        line-height: 1.4;
        transition: 0.3s;
      }
    }

    p.text {
      font-weight: 500;
      font-family: font-medium;
      font-size: 18px;
      text-align: center;
      line-height: 1.7;
      transition: 0.3s;
    }
  }
`;
